export const CustomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.28 30">
    <g>
      <path
        d="M10.82,25.38l3.81-11.17L10.82,6.83H22.49L38,14.21"
        fill="#73b0ac"
        stroke="#f7931e"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <circle cx="14.38" cy="14.42" r="1.32" fill="#fff" />
      <circle cx="22.24" cy="6.83" r="1.32" fill="#fff" />
      <circle cx="10.82" cy="6.83" r="1.32" fill="#fff" />
      <circle cx="37.97" cy="14.14" r="1.32" fill="#fff" />
      <circle cx="10.82" cy="25.35" r="1.32" fill="#fff" />
    </g>
  </svg>
)
